import { useState } from 'react'
import { Button } from '../../components/button'
import Icon from '../../components/icon'
import { AddWalletAmountModal } from '../../components/modal/app_modals/addWalletAmountModal'
import { ConfirmationModal } from '../../components/modal/app_modals/confirmationModal'
import Spinner from '../../components/spinner/Spinner'
import { TableComponent } from '../../components/table'
import { HeaderSubheader } from '../../components/typography/HeaderSubheader'
import { formatCurrency } from '../../helpers'
import { useModalControl } from '../../hooks/useModalControl'
import { useFetchWalletAmountsQuery } from '../../redux-toolkits/user/user.slice'
import { WalletAmount } from '../../redux-toolkits/user/user.type'

export const WalletSettings = () => {
  const [selectedAmount, setSelectedAMount] = useState<WalletAmount>()

  const { modalOpen, modal, handleModalClose, handleModalOpen, setModalOpen } =
    useModalControl()

  const { data, isFetching } = useFetchWalletAmountsQuery()

  if (isFetching) {
    return (
      <div
        className="
        flex items-center justify-center
      "
      >
        <Spinner fullScreen={false} />
      </div>
    )
  }
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <HeaderSubheader
          title="Wallet"
          text="Configure quick fund amounts"
          className="max-w-fit"
        />

        <Button
          label={'Add Quick Fund Amount'}
          primary
          onClick={() => {
            handleModalOpen('addWalletAmountModal')
          }}
          size="medium"
          className="min-w-fit"
          type="button"
        />
      </div>

      <div className="w-full overflow-x-scroll max-w-[620px]">
        <TableComponent
          sortable={false}
          headers={['Amount']}
          rows={
            data?.data?.docs?.length
              ? data?.data?.docs?.map((item, idx) => {
                  return {
                    id: `${item._id}`,
                    content: [
                      <div
                        key={`${item._id}`}
                        className="
                      w-full
                      flex items-center justify-between
                      gap-4
                      "
                      >
                        {formatCurrency(item.amount)}
                        <button
                          type="button"
                          className="flex items-center gap-2 text-danger"
                          onClick={() => {
                            setSelectedAMount(item)
                            handleModalOpen('confirmAmountDeletionModal')
                          }}
                        >
                          <Icon width={14} height={14} id="bin" />
                          Delete
                        </button>
                      </div>,
                    ],
                  }
                })
              : []
          }
          name="quick-fund-table"
          loading={false}
          isEmpty={[undefined, 0].includes(data?.data?.docs?.length)}
          currentPage={1}
          totalDataCount={undefined}
          pageLimit={undefined}
          onPageChange={(page) => {}}
        />
      </div>

      <AddWalletAmountModal
        open={modalOpen && modal === 'addWalletAmountModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={() => {}}
      />

      <ConfirmationModal
        open={modalOpen && modal === 'confirmAmountDeletionModal'}
        setOpen={setModalOpen}
        message="Are you sure you want to proceed? This action cannot be reversed."
        onCloseCallback={() => {
          handleModalClose()
          setSelectedAMount(undefined)
        }}
        onConfirm={() => {}}
        loading={false}
      />
    </div>
  )
}
